import { ICancerRejection } from './cancer-rejection';
import { ICancerRejectionList } from './cancer-rejection-list';
import { IKidneyStoneRejection } from './kidney-stone-rejection';


export interface IReferralConfigRequest {
        centerId: number,
        isRegistrationEnabled: boolean,
        useQuickStart: boolean,
        useAdpDefaults: boolean,
        useReducedQuestions: boolean,
        useCystatinC: boolean,
        offerDonorConnect: boolean,
        offerRuleOutTransfer: boolean,
        isDonorConnectLiverEnabled: boolean,
        isDonorConnectNegC: boolean,
        distanceToRefer: number,
        askSexualSocialQuestions: boolean,
        askForId: boolean,
        doRealTimeEval: boolean,
        callbackBusinessDays: number,
        dashDonorDaysToExpire: number,
        yearsForFollowUpLabs: number,
        recipientMaxAge: number,
        donorMaxAge: number,
        intakeWorkflowConfig: number,
        dashDonorDaysToExpireText: string,
        dashUsesPwlQuest: boolean,
        dashUsesLiverPwl: boolean,
        dashUsesPwlPhlebot: boolean,
        dashUsesPwlAtMiles: number,
        dashUsesFiveStar: boolean,
        usesPwlForNdd: boolean,
        usesPwlForAdp: boolean,
        usesPwlForLongDistanceDonors: boolean,
        bmiLimit: number,
        bmiRequiredForSurgery: number,
        bmiLimitLiver: number,
        bmiRequiredForSurgeryLiver: number,
        minAgeNdd: number,
        minAgeDd: number,
        mustAcceptBloodTransfusions: boolean,
        ruleOutOnGestationalDiabetes: boolean,
        ruleOutOnKidneyDisease: boolean,
        ruleOutOnHiv: boolean,
        alwaysRuleOutOnHeartAttack: boolean,
        requireQuitTobacco: boolean,
        heartAttackRemissionRequired: number,
        diabetesFailLevel: number,
        plDashPhoneNumber: string,
        plDashPhoneIsDisplayed: boolean,
        ruleOutOnPregnancy: boolean,
        ruleOutOnPregnancyWaitTime: number,
        ruleOutOnNursing: boolean,
        liverRuleOutLiverDisease: boolean,
        liverRuleOutKidneyDisease: boolean,
        liverRuleOutHepB: boolean,
        liverRuleOutHepC: boolean,
        liverRuleOutDiabetes: boolean,
        liverDonorMaxAge: number,
        expertSystemAutomated: boolean,
        followUpKitId: number,
        followUpAllowPhlebot: boolean,
        expireToQueuePostScreening: boolean,
        preWorkupLabConfig: number,
        referralSources: string[],
        cancerRejection: ICancerRejection[];
        cancerRejectionList: ICancerRejectionList[];
        kidneyStoneRejection: IKidneyStoneRejection[];
        cancerRejectionJson: string;
        kidneyStoneRejectionJson: string;
        isStandardVoucherLinkOption: number;
        isFamilyVoucherLinkOption: number;
}
